import React, { lazy } from "react";
import Header from "../components/layout/Header/Header.jsx";
import Hero from "../components/sections/HeroSection/Hero.jsx";
import Footer from "../components/layout/Footer/Footer.jsx";
import TravelConsultation from "../components/layout/TravelConsultation/TravelConsultation.jsx";

// Ленивая загрузка секций, которые находятся ниже первого экрана
const PreviewSection = lazy(
  () => import("../components/sections/previewSection/previewSection.jsx"),
);
const CulturalLeisure = lazy(
  () => import("../components/sections/CulturalSection/CulturalSection.jsx"),
);
const OutdoorSection = lazy(
  () => import("../components/sections/OutdoorSection/OutdoorSection.jsx"),
);
const ExtremeSection = lazy(
  () => import("../components/sections/ExtremeSection/ExtremeSection.jsx"),
);
const WhyUsSection = lazy(
  () => import("../components/sections/WhyUsSection/WhyUsSection.jsx"),
);
const HotelSection = lazy(
  () => import("../components/sections/HotelSection/HotelSection.jsx"),
);
const RestoranSection = lazy(
  () => import("../components/sections/RestoranSection/RestoranSection.jsx"),
);
const ServicesSection = lazy(
  () => import("../components/sections/ServicesSection/ServicesSection.jsx"),
);

function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero id="hero" />
        <PreviewSection id="preview" />
        <CulturalLeisure id="cultural" />
        <OutdoorSection id="outdoor" />
        <ExtremeSection id="extreme" />
        <ServicesSection id="services" />
        <RestoranSection id="restaurants" />
        <HotelSection id="hotels" />
        <WhyUsSection id="about" />
        <TravelConsultation id="consultation" />
      </main>
      <Footer />
    </>
  );
}

export default Home;
